import { ApiService } from './../../../api/api.service';
import { AppInjector } from './../../../app-injector';
import { Subscription } from 'rxjs/Subscription';
import { Component, OnInit, OnDestroy } from '@angular/core';
import store from './../../../store/store.module';
import {
  TOGGLE_PAYMENT_TYPE,
  CREATE_PAYMENT_ITEM_REQEUSTED,
  FETCH_PAYMENT_DETAIL_REQUESTED,
} from './pay.actions';
import * as _ from 'lodash';
import { NotificationService } from '../../../common/services/notification/notification.service';
import { ActivatedRoute, Router, NavigationEnd } from '@angular/router';
import {GET_PAYMENT_METHODS_REQUESTED} from "../edit/edit.actions";
import {UtilityService} from "../../../common/services/utility/utility.service";

@Component({
  selector: 'app-create',
  templateUrl: './pay.component.html',
  styleUrls: ['./pay.component.scss']
})
export class PayComponent implements OnInit, OnDestroy {
  public navigationSubscription: Subscription;
  public store = store;
  public data = {
    amount: 0,
    comment: ''
  };
  public currency = 'SGD';
  public paymentDetailData = {};
  public attributes = [];
  public paymentMethodId = null;
  public utilityService;
  public noModifyDefault = false;
  public redirectData;
  constructor(private notification: NotificationService, private activeRouter: ActivatedRoute, private router: Router, utilityService: UtilityService) {
    this.utilityService = utilityService;
    this.activeRouter = activeRouter;
    this.router = router;
    this.navigationSubscription = this.router.events.subscribe((e: any) => {
      if (e instanceof NavigationEnd) {
        this.data = {
          amount: 0,
          comment: ''
        };
        store.dispatch({
          type: GET_PAYMENT_METHODS_REQUESTED
        });
        store.dispatch({
          type: FETCH_PAYMENT_DETAIL_REQUESTED,
          id: this.activeRouter.snapshot.params.id
        });

        let unsubscribe = store.subscribe(() => {
          if ((store as any).getState().Payment.pay.initialized) {
            const paymentDetail = (store as any).getState().Payment.pay.data.default_payment_detail;
            if (paymentDetail) {
              this.changeMethod(paymentDetail.payment_method_id);
            }
            if ((store as any).getState().Payment.pay.data.currency) {
              this.currency = (store as any).getState().Payment.pay.data.currency.code;
            }
            unsubscribe();
          }
        });
      }
    });
  }
  ngOnInit() {
    this.redirectData = this.utilityService.getRedirectData();
  }
  copyValue (paymentDetail, paymentMethod) {
    if (paymentDetail && paymentDetail.payment_method_id) {
      this.paymentMethodId = paymentDetail.payment_method_id;
      this.attributes = Object.keys(paymentDetail.data);
      if(!_.isNil(paymentMethod.required_value) && Array.isArray(paymentMethod.required_value)){
       this.attributes = _.uniq([...this.attributes, ...paymentMethod.required_value])
      }
    }
    this.paymentDetailData = {};
    this.attributes.forEach(s => {
      this.paymentDetailData[s] = paymentDetail.data[s];
    });
  }
  changeMethod(paymentMethodId) {
    const paymentMethod = (store as any).getState().Payment.edit.paymentMethods.find(s => parseInt(s.id) === parseInt(paymentMethodId));
    if (paymentMethod) {
      const paymentDetail = (store as any).getState().Payment.pay.data.default_payment_detail;
      if (paymentDetail && paymentDetail.payment_method && paymentDetail.payment_method.id === paymentMethod.id) {
        this.copyValue(paymentDetail, paymentMethod);
      } else {
        if ((store as any).getState().Customer.edit.fetched) {
          let paymentObjectType = (store as any).getState().Payment.pay.data.object_type;
          if ((store as any).getState().Customer.edit.item.email === (store as any).getState().Payment.pay.data[paymentObjectType].getEmail()) {
            const suggestedPaymentDetail = (store as any).getState()
              .Customer.edit.item.customer.payment_details.getContent().find(s => parseInt(s.payment_method_id) === parseInt(paymentMethod.id));
            if (suggestedPaymentDetail) {
              this.copyValue(suggestedPaymentDetail, paymentMethod);
              return;
            }
          }
        }
        this.paymentMethodId = paymentMethod.id;
        this.attributes = paymentMethod.required_value;
        this.paymentDetailData = {};
        this.attributes.forEach(s => {
          this.paymentDetailData[s] = '';
        });
      }
    }
  }
  getKey(key) {
    return key.split('_').map(s => {
      return s[0].toUpperCase() + s.substring(1);
    }).join(' ');
  }
  ngOnDestroy() {
    if (!_.isUndefined(this.navigationSubscription)) {
      this.navigationSubscription.unsubscribe();
    }
  }
  changePaymentType(type) {
    store.dispatch({ type: TOGGLE_PAYMENT_TYPE, val: type});
  }
  pay(form) {
    if (!form.invalid) {
      this.data['type'] = this.store.getState().Payment.pay.type;
      this.checkToAssignPaymentDetail();
      store.dispatch({ type: CREATE_PAYMENT_ITEM_REQEUSTED,
        id: this.store.getState().Payment.pay.data.id,
        data: this.data,
        next: this.redirectData ? this.redirectData.page : 'payment/' + this.store.getState().Payment.pay.data.payment_type,
        nextParams: this.redirectData ? this.redirectData.defaultValue : null
      });
    }
  }
  forceComplete() {
    this.data['type'] = this.store.getState().Payment.pay.type;
    this.data['comment'] = "(FORCE COMPLETED)" + (this.data['comment'] ? this.data['comment'] : '');
    this.data['force_complete'] = true;
    this.checkToAssignPaymentDetail();
    store.dispatch({ type: CREATE_PAYMENT_ITEM_REQEUSTED,
      id: this.store.getState().Payment.pay.data.id,
      data: this.data,
      next: this.redirectData ? this.redirectData.page : 'payment/' + this.store.getState().Payment.pay.data.payment_type,
      nextParams: this.redirectData ? this.redirectData.defaultValue : null
    });
  }

  markAsSent = () =>{
    this.data['type'] = this.store.getState().Payment.pay.type;
    this.data['comment'] = "(MARK AS SENT)" + (this.data['comment'] ? this.data['comment'] : '');
    this.checkToAssignPaymentDetail();
    const routerParams = {
      next: this.redirectData ? this.redirectData.page : 'payment/' + this.store.getState().Payment.pay.data.payment_type,
      nextParams: this.redirectData ? this.redirectData.defaultValue : null
    }
    AppInjector.get(ApiService).payment.markAsSend(this.store.getState().Payment.pay.data.id, this.data).subscribe((res) => {
      this.router.navigate([routerParams.next], {queryParams: {untouched: true, ...(routerParams.nextParams ? routerParams.nextParams : {})}});
    }, (error) => {
      AppInjector.get(NotificationService).show('warning', `${error.message}`, 3000);
    })

  }

  checkToAssignPaymentDetail() {
    if (this.store.getState().Payment.pay.data.payment_type === 'SEND') {
      if (this.paymentDetailData && this.paymentMethodId) {
        this.data['payment_detail'] = {
          'data': this.paymentDetailData,
          'payment_method_id': this.paymentMethodId,
          'no_modify_default': this.noModifyDefault
        };
      }
    }
  }
}
